import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé toda mi planificación anual de matemática en un fin de semana. Ahora sé exactamente qué secuencia dar cada semana y cómo evaluarla. Nunca más llego al lunes sin saber qué hacer.',
  name: 'Marcela D.',
  location: 'Buenos Aires',
  role: 'Docente de 3° Grado, Escuela Primaria Pública'
}, {
  quote: 'Las secuencias didácticas cambiaron todo. Mis alumnos entendieron las fracciones en 2 semanas después de que yo llevara un año sin saber cómo explicarlas bien. Y los padres empezaron a notar la diferencia.',
  name: 'Rodrigo F.',
  location: 'Rosario',
  role: 'Docente de 5° Grado, Escuela Primaria de Gestión Privada'
}, {
  quote: 'Adapto las fichas según el grupo en 10 minutos. Antes me llevaba horas buscar actividades en internet para armar algo que tenga sentido pedagógico.',
  name: 'Graciela M.',
  location: 'Córdoba',
  role: 'Docente de 4° Grado, lleva 18 años en el aula'
}];
export const Testimonials = () => {
  return <section className="py-16 bg-white" data-id="element-258">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-260">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-cream-dark p-8 rounded-2xl shadow-card border border-brand-orange/10 relative" data-id="element-261">
              <div className="flex gap-1 mb-4" data-id="element-262">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} className="text-brand-gold fill-brand-gold" data-id="element-263" />)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-264">
                "{t.quote}"
              </p>
              <div data-id="element-265">
                <p className="font-bold text-gray-900" data-id="element-266">
                  {t.name}{' '}
                  <span className="text-brand-orange font-normal" data-id="element-267">
                    — {t.location}
                  </span>
                </p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-268">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};